import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducers/store";
import Card from "../../vapor/card";
import Tooltip from "../../vapor/tooltip";
import "./style.scss";

interface ProductCardProps {
    id: string;
    item: any;
    onSelect: () => void;
}

const ProductCard = (props: ProductCardProps) => {
    const credits = useSelector(
        (state: RootState) => state.userPackage?.credits,
    );
    const hasExtra = useSelector(
        (state: RootState) => state.userPackage?.negative_credits,
    );
    const hasSufficientCredits =
        (credits && props.item && credits >= props.item.price) || hasExtra
            ? true
            : false;
    const productDescription = props.item ? props.item.description : "";
    const productName = props.item ? props.item.name : "";

    useEffect(() => {
        const elFind = document.getElementById(props.id);
        if (elFind) {
            const titleFind = elFind.getElementsByClassName(
                "bis-product-card-title",
            );
            const descFind = elFind.getElementsByClassName(
                "bis-product-card-content-description",
            );
            if (
                titleFind &&
                titleFind.length > 0 &&
                descFind &&
                descFind.length > 0
            ) {
                if (titleFind[0].clientHeight > 50) {
                    descFind[0].classList.add("twoLines");
                }
            }
        }
    });

    let productFormat = "";
    if (props.item && props.item.formats) {
        const uniqueProductFormats: string[] = Array.from(
            new Set(props.item.formats),
        );
        uniqueProductFormats.map((format: string) => {
            if (format.toUpperCase() === "JSON") {
                return null;
            }
            return (productFormat += `${productFormat.length > 0 ? ", " : ""}${format}`);
        });
    }
    if (productFormat.length === 0) {
        productFormat = "N/A";
    }

    const content = (
        <>
            <div className="bis-product-card-content" id={props.id}>
                <div className="bis-product-card-title">
                    <div className="bis-product-card-title-icon">
                        <FontAwesomeIcon
                            icon={[
                                "far",
                                props.item?.product &&
                                ["BILANCIO_XBRL", "BILANCIO_COMPLETO"].indexOf(
                                    props.item?.product,
                                ) > -1
                                    ? "code"
                                    : "file-pdf",
                            ]}
                        />
                    </div>
                    <Tooltip content={productName} direction="bottom">
                        <div className="bis-product-card-title-text">
                            {productName}
                        </div>
                    </Tooltip>
                </div>
                <div className="bis-product-card-content-description">
                    {productDescription || <>&nbsp;</>}
                </div>
                <div className="bis-product-card-content-bottom">
                    <div>
                        <FormattedMessage id="widgets.productCard.format" />:{" "}
                        <span>{productFormat}</span>
                    </div>
                    <div>
                        <FormattedMessage id="widgets.productCard.price" />:{" "}
                        <span>
                            {props.item?.price}{" "}
                            <FormattedMessage id="widgets.productCard.credits" />
                        </span>
                    </div>
                </div>
            </div>
        </>
    );

    return (
        <Card
            disabled={false}
            title=""
            footer={
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <div
                        className={
                            hasSufficientCredits
                                ? "bis-product-card-add"
                                : "bis-product-card-add disabled"
                        }
                        onClick={() =>
                            hasSufficientCredits ? props.onSelect() : {}
                        }
                    >
                        <FontAwesomeIcon icon={["far", "shopping-cart"]} />
                    </div>
                </div>
            }
            height={209}
            width={395}
            horizontal
        >
            {content}
        </Card>
    );
};
export default ProductCard;
